import { render, staticRenderFns } from "./ListaCliente.vue?vue&type=template&id=f721f2b8&scoped=true"
import script from "./ListaCliente.vue?vue&type=script&lang=js"
export * from "./ListaCliente.vue?vue&type=script&lang=js"
import style0 from "./ListaCliente.vue?vue&type=style&index=0&id=f721f2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f721f2b8",
  null
  
)

export default component.exports